export default __webpack_public_path__ + "static/media/Ramadan.f22d7943.jpg";